import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SiteSvgsComponent } from '@curbnturf/custom-svgs/src/lib/site-svgs/site-svgs.component';

@Component({
  selector: 'curbnturf-rating-rate',
  templateUrl: './rating-rate.component.html',
  styleUrls: ['./rating-rate.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RatingRateComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => RatingRateComponent),
      multi: true,
    },
  ],
  standalone: true,
  imports: [SiteSvgsComponent],
})
export class RatingRateComponent implements ControlValueAccessor {
  @Input() rating: number;

  @Input() disabled: boolean = false;

  @Output() ratingChange: EventEmitter<number> = new EventEmitter<number>();

  onChange: (rating: number) => void;
  onTouched: () => void;

  writeValue(obj: number): void {
    this.rating = obj;
  }

  registerOnChange(fn: (rating: number) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  rate(value: number) {
    if (!this.disabled) {
      this.rating = value;
      this.ratingChange.emit(this.rating);
      this.onChange(this.rating);
      this.onTouched();
    }
  }

  isFullStar(value: number) {
    return this.rating >= value;
  }

  isHalfStar(value: number) {
    return this.rating < value && this.rating > Math.floor(value);
  }

  getStars(value: number) {
    if (this.isFullStar(value)) {
      return 'rating-star-full';
    } else if (this.isHalfStar(value)) {
      return 'rating-star-half';
    } else {
      return 'rating-star-empty';
    }
  }

  validate({ value }: FormControl) {
    const isNotValid = value <= 0 || value > 5;
    return (
      isNotValid && {
        invalid: true,
      }
    );
  }
}
